import React, { useState } from 'react'
import imagePlaceholder from '../../images/no-camera-icon.png'
import styles from './common.module.scss'
import { Button, Modal } from '@material-ui/core'

export const formatCI = (ci) => {
  if (!ci) return ''
  if (isNaN(ci)) {
    return ci
  }
  let cedulaStr = ci?.toString()
  let parte1 =
    cedulaStr.slice(0, 1) +
    '.' +
    cedulaStr.slice(1, 4) +
    '.' +
    cedulaStr.slice(4, 7)

  let digitoVerificador = cedulaStr.slice(-1)
  return parte1 + '-' + digitoVerificador
}

const ShowImageTable = ({ name, imageUrl, ci }) => {
  const [isImageError, setIsImageError] = useState(false)

  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')

  const [showModal, setShowModal] = useState(false)

  const handleImageClick = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleImageError = () => {
    setIsImageError(true)
  }

  return (
    <div>
      {imageUrl && !isImageError ? (
        <div className={styles.userImageContainer}>
          <img
            src={imageUrl}
            alt="guest"
            className={styles.image}
            onClick={handleImageClick}
            onError={handleImageError}
          />
          <div>
            <div className={styles.text}>{name}</div>
            <div className={styles.ciText}>{formatCI(ci)}</div>
          </div>
        </div>
      ) : (
        <div className={styles.userImageContainer}>
          <div className={styles.imagePlaceholder}>{initials}</div>
          <div>
            <div className={styles.text}>{name}</div>
            <div className={styles.ciText}>{formatCI(ci)}</div>
          </div>
        </div>
      )}

      <Modal open={showModal} onClose={handleCloseModal}>
        <div className={styles.modal}>
          <div>
            <img
              src={imageUrl}
              alt="guest"
              className={styles.modalImage}
              width={500}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ShowImageTable
